
import { Outlet } from "react-router-dom";
import { Footer } from "./Footer";
import { useViewMode } from "@/contexts/ViewModeContext";
import { useLocation } from "react-router-dom";

export const Layout = () => {
  const { isLivestream } = useViewMode();
  const location = useLocation();

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow flex flex-col pb-3 sm:pb-5 px-1 sm:px-0">
        <Outlet />
      </main>
      {!(isLivestream && location.pathname === "/game") && <Footer />}
    </div>
  );
};
